import { connect } from "react-redux";
import React, { Fragment, useCallback, useEffect } from "react";
import cx from "classnames";
import { useDispatch, useSelector } from "react-redux";

import Nav from "./VerticalNavWrapper";
import {
  CSSTransition,
  TransitionGroup,
} from "../../../utils/TransitionWrapper";

import { setEnableMobileMenu } from "../../../reducers/ThemeOptions";

const AppSidebar: React.FC = () => {
  const dispatch = useDispatch();

  const {
    enableBackgroundImage,
    enableSidebarShadow,
    enableMobileMenu,
    backgroundColor,
    backgroundImage,
    backgroundImageOpacity,
  } = useSelector((state: any) => state.ThemeOptions);

  const toggleMobileSidebar = useCallback(() => {
    dispatch(setEnableMobileMenu(!enableMobileMenu));
  }, [dispatch, enableMobileMenu]);


  return (
    <Fragment>
      <div className="sidebar-mobile-overlay" onClick={toggleMobileSidebar} />

      <TransitionGroup>
        <CSSTransition
          component="div"
          className={cx("app-sidebar z-[100]", backgroundColor, {
            "sidebar-shadow": enableSidebarShadow,
          })}
          appear
          enter={false}
          exit={false}
          timeout={500}
        >
          <div>
            <div className="app-sidebar__inner">
              <Nav />
            </div>

            <div
              className={cx("app-sidebar-bg", backgroundImageOpacity)}
              style={{
                backgroundImage:
                  enableBackgroundImage && backgroundImage
                    ? `url(${backgroundImage})`
                    : undefined,
              }}
            />
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
  enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  backgroundColor: state.ThemeOptions.backgroundColor,
  backgroundImage: state.ThemeOptions.backgroundImage,
  backgroundImageOpacity: state.ThemeOptions.backgroundImageOpacity,
});

const mapDispatchToProps = (dispatch: any) => ({
  setEnableMobileMenu: (enable: any) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppSidebar);
